import CityModel from '../assets/svg/bg/bg_3dcitymodel.svg';
import About from '../assets/svg/bg/bg_about.svg';
import Interview from '../assets/svg/bg/bg_interview.svg';
import Top from '../assets/svg/bg/top_bg.svg';
import { History, HistoryEvent } from '../router/History';
import EventDispatcher from '../core/EventDispatcher';

export enum BackgroundEvent {
	CHANGE,
};

export default class Background extends EventDispatcher<BackgroundEvent>
{
	currentBG;
	defaultBG;
	history = new History();

	_routeBG = {};
	
	constructor(data:any)
	{
		super();
		this._buildRouteBGs(data);
		this.currentBG = this.getBG(this._routeBG[this.history.path]);
		this.history.on(HistoryEvent.CHANGE, this._historyChange);
	}

	_buildRouteBGs(routeData, parentPath = '')
	{
		if(!routeData['routes']) return;
		for (let [path, data] of Object.entries(routeData['routes']))
		{
			path = '/' + parentPath + '/' + path + '/';
			path = path.replace(/\/+/g, '/');
			if(data['routes'])
			{
				this._buildRouteBGs(data, path);
			}
			if(data['bg'])
			{
				this._routeBG[path] = data['bg'];
			}
		}
	}

	_historyChange = (e) =>
	{
		let bg = this.getBG(this._routeBG[this.history.path]);
		if(bg != this.currentBG)
		{
			this.currentBG = bg;
			this.trigger(BackgroundEvent.CHANGE);
		}
	}

	getBG(name:string)
	{
		switch(name)
		{
			case 'About':
				return About;
			case 'CityModel':
				return CityModel;
			case 'Interview':
				return Interview;
			case 'none':
				return null;
			default:
				return Top;
		}
	}

}
